export default ({ theme }) => `
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 10px;
  border-bottom: 1px solid ${theme.borderColor};

  @media(max-width: 768px) {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    justify-content: space-between;
  }
`;
